/* eslint-disable */
import _ from 'lodash'
import React from 'react'
import { PropTypes } from 'prop-types'
import { Row, Col, Button, Panel } from 'react-bootstrap'
import ReactTable from 'react-table'
import styles from './styles'
import { warning, blue } from '../../../utils/constants'
import 'react-table/react-table.css'
import ContentWrapper from '../../layout/ContentWrapper'
import { postStandardGames, postBakerGames, postStandardBowlers, postBakerBowlers } from './api'

class AmendScores extends React.Component {
    constructor() {
        super()
        this.state = {
            saving: false,
            saved: false,
            pristine: true,
            changedBakerScores: [],
            changedBakerBowlers: [],
            changedStandardGames: [],
            changedStandardBowlers: [],
            bakerScoresData: [],
            _bakerScoresData: null,
            bakerBowlersData: [],
            _bakerBowlersData: null,
            standardGamesFlatData: [],
            _standardGamesFlatData: null,
        }
    }

    componentDidMount() {
        const { teamScores } = this.props;
        const { standardGames, bakerScores, bakerBowlers } = teamScores;

        const standardGamesFlatData = this.flattenBowlerStandardGames(standardGames);

        this.setState({
            bakerScoresData: bakerScores,
            bakerBowlersData: bakerBowlers,
            standardGamesFlatData,
            _bakerScoresData: [...bakerScores.map(item => Object.assign({}, item))],
            _bakerBowlersData: [...bakerBowlers.map(item => Object.assign({}, item))],
            _standardGamesFlatData: [...standardGamesFlatData.map(item => Object.assign({}, item))],
        });
    }

    handleSaveStandardData = () => {
        const { changedStandardGames, changedStandardBowlers, pristine } = this.state;
        const { token } = this.props;
        const _this = this;

        if (!pristine) {
            this.setState({
                saving: true,
                saved: false
            });

            if (changedStandardGames.length > 0)
            {
                const scoreUpdates = {
                    scores: changedStandardGames
                };

                postStandardGames(scoreUpdates, token).then(function () {
                    _this.setState({
                        saving: false,
                        pristine: true,
                        saved: true,
                        changedStandardGames: [],
                    }, () => {
                        _this.resetStandardScoresChangeTracking();
                    });
                });
            }

            if (changedStandardBowlers.length > 0)
            {
                const bowlerUpdates = {
                    standardBowlers: changedStandardBowlers
                };

                postStandardBowlers(bowlerUpdates, token).then(function () {
                    _this.setState({
                        saving: false,
                        pristine: true,
                        saved: true,
                        changedStandardBowlers: []
                    }, () => {
                        _this.resetStandardBowlersChangeTracking();
                    });
                });
            }
        }
    }

    handleSaveBakerScores = () => {
        const { changedBakerScores: changedBakerScores, pristine } = this.state
        const { token } = this.props
        const _this = this

        if (!pristine) {
            this.setState({
                saving: true,
                saved: false
            })

            const updates = {
                scores: changedBakerScores
            }
            postBakerGames(updates, token).then(function () {
                _this.setState({
                    saving: false,
                    pristine: true,
                    saved: true,
                    changedBakerScores: []
                }, () => {
                    _this.resetBakerScoresChangeTracking();
                });

            })
        }
    }

    handleSaveBakerBowlers = () => {
        const { changedBakerBowlers: changedBakerBowlers, pristine } = this.state
        const { token } = this.props
        const _this = this

        if (!pristine) {
            this.setState({
                saving: true,
                saved: false
            })

            const updates = {
                bakerbowlers: changedBakerBowlers
            }
            postBakerBowlers(updates, token).then(function () {
                _this.setState({
                    saving: false,
                    pristine: true,
                    saved: true,
                    changedBakerBowlers: []
                }, () => {
                    _this.resetBakerBowlersChangeTracking();
                });

            })
        }
    }

    renderEditableBowlerName = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => this.checkForBowlerChanges(cellInfo.index, (game) => { game.bowlerName = e.target.innerHTML; })}
                dangerouslySetInnerHTML={{
                    __html: ((this.state.standardGamesFlatData || {})[cellInfo.index] || {})[cellInfo.column.id] || ""
                }}
            />
        )
    }
    
    renderEditableBowlerId = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => this.checkForBowlerChanges(cellInfo.index, (game) => { game.bowlerId = e.target.innerHTML; })}
                dangerouslySetInnerHTML={{
                    __html: ((this.state.standardGamesFlatData || {})[cellInfo.index] || {})[cellInfo.column.id] || ""
                }}
            />
        )
    }

    renderEditableBowled = (cellInfo) => {
        return (
            <div>
                <select
                    defaultValue={cellInfo.value}
                    onBlur={e => this.checkForBowlerChanges(cellInfo.index, (game) => { game.bowled = e.target.value; })}
                >
                    <option value="false">No</option>
                    <option value="true">Yes</option>
                </select>
            </div>
        )
    }

    checkForBowlerChanges = (gameIndex, f) => {
        const currentStandardGame = this.state.standardGamesFlatData[gameIndex];
        const trackedStandardGame = this.state._standardGamesFlatData[gameIndex];                    

        if (currentStandardGame && trackedStandardGame)
        {
            const individualScoreId = currentStandardGame.individualScoreId;

            if (individualScoreId)
            {
                f(currentStandardGame);
                const changedStandardBowlers = [...this.state.changedStandardBowlers.filter(b => b.individualScoreId != individualScoreId)];

                if (this.bowlerHasChanges(currentStandardGame, trackedStandardGame)) {
                    changedStandardBowlers.push(currentStandardGame);
                }

                this.setState({ pristine: changedStandardBowlers.length == 0, changedStandardBowlers });
            }
        }
    }

    renderEditableStandardScores = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    const currentStandardGame = this.state.standardGamesFlatData[cellInfo.index];
                    const trackedStandardGame = this.state._standardGamesFlatData[cellInfo.index];                    

                    if (currentStandardGame && trackedStandardGame)
                    {
                        const individualScoreId = currentStandardGame.individualScoreId;

                        if (individualScoreId)
                        {
                            const newScore = parseInt(e.target.innerHTML, 10);
                            currentStandardGame[cellInfo.column.id] = isNaN(parseFloat(newScore)) ? 0 : newScore;
                            const individualGameScoreId = currentStandardGame[cellInfo.column.id.replace("gameNo","gameId")];
                            const individualCombinedScoresId = currentStandardGame[cellInfo.column.id.replace("gameNo","combinedScoresId")];
                            const changedStandardGames = [...this.state.changedStandardGames.filter(b => b.individualGameScoreId != individualGameScoreId)];                            

                            if (currentStandardGame[cellInfo.column.id] != trackedStandardGame[cellInfo.column.id]) {
                                if (individualGameScoreId && individualCombinedScoresId) {
                                    changedStandardGames.push({
                                        individualGameScoreId,
                                        individualCombinedScoresId,
                                        score: currentStandardGame[cellInfo.column.id]
                                    });
                                }
                            }

                            this.setState({ pristine: changedStandardGames.length == 0, changedStandardGames });
                        }
                    }
                }}
                dangerouslySetInnerHTML={{
                    __html: ((this.state.standardGamesFlatData || {})[cellInfo.index] || {})[cellInfo.column.id] || ""
                }}
            />
        )
    }

    renderEditableBakerScores = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    const bakerScoresData = [...this.state.bakerScoresData]
                    const changedBakerScores = [...this.state.changedBakerScores]
                    const row = cellInfo.index
                    const id = this.state.bakerScoresData[row].bakerGameScoreId
                    const originalScore = parseInt(this.state.bakerScoresData[row].score)
                    var newScore = parseInt(e.target.innerHTML, 10)
                    newScore = isNaN(parseFloat(newScore)) ? 0 : newScore
                    bakerScoresData[row][cellInfo.column.id] = newScore

                    if (originalScore !== newScore) {
                        const exists = _.find(changedBakerScores, ['bakerGameScoreId', id])

                        if (exists === undefined) {
                            changedBakerScores.push(this.state.bakerScoresData[row])
                        }
                    }
                    this.setState({ bakerScoresData, pristine: false, changedBakerScores })
                }}
                dangerouslySetInnerHTML={{
                    __html: ((this.state.bakerScoresData || {})[cellInfo.index] || {})[cellInfo.column.id] || "0"
                }}
            />
        )
    }

    renderEditableBakerBowlersName = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => this.checkForBakerBowlerChanges(cellInfo.index, (game) => { game.bowlerName = e.target.innerHTML; })}
                dangerouslySetInnerHTML={{
                    __html: ((this.state.bakerBowlersData || {})[cellInfo.index] || {})[cellInfo.column.id] || ""
                }}
            />
        )
    }

    renderEditableBakerBowlersID = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => this.checkForBakerBowlerChanges(cellInfo.index, (game) => { game.bowlerId = e.target.innerHTML; })}
                dangerouslySetInnerHTML={{
                    __html: ((this.state.bakerBowlersData || {})[cellInfo.index] || {})[cellInfo.column.id] || ""
                }}
            />
        )
    }

    renderEditableBakerBowlersBowled = (cellInfo) => {
        return (
        <div>            
            <select
                defaultValue={cellInfo.value}
                onBlur={e => this.checkForBakerBowlerChanges(cellInfo.index, (game) => { game.bowled = e.target.value; })}
            >
                <option value="false">No</option>
                <option value="true">Yes</option>
            </select>
        </div>
    )}

    checkForBakerBowlerChanges = (gameIndex, f) => {
        const currentBowler = this.state.bakerBowlersData[gameIndex];
        const trackedBowler = this.state._bakerBowlersData[gameIndex];                    

        if (currentBowler && trackedBowler)
        {
            const bakerScoresBowlersId = currentBowler.bakerScoresBowlersId;

            if (bakerScoresBowlersId)
            {
                f(currentBowler);

                const changedBakerBowlers = [...this.state.changedBakerBowlers.filter(b => b.bakerScoresBowlerId != bakerScoresBowlersId)];

                if (this.bowlerHasChanges(currentBowler, trackedBowler)) {
                    changedBakerBowlers.push(currentBowler);
                }

                this.setState({ pristine: changedBakerBowlers.length == 0, changedBakerBowlers });
            }
        }
    }

    resetBakerBowlersChangeTracking = () => {
        const _bakerBowlersData = this.state._bakerBowlersData ? [...this.state._bakerBowlersData] : [...this.state.bakerBowlersData];

        for (var i = 0; i < _bakerBowlersData.length; i++) {
            const currentState = this.state.bakerBowlersData[i];
            const trackedState = _bakerBowlersData[i];

            trackedState.bowlerName = currentState.bowlerName;
            trackedState.bowlerId = currentState.bowlerId;
            trackedState.bowled = currentState.bowled;
        }

        this.setState({
            _bakerBowlersData
        })
    }

    bakerBowlerHasChanges = (a, b) => {
        return ((a.bowlerName != b.bowlerName) || (a.bowlerId != b.bowlerId) || (a.bowled != b.bowled));
    }

    resetBakerScoresChangeTracking = () => {
        const _bakerScoresData = this.state._bakerScoresData ? [...this.state._bakerScoresData] : [...this.state.bakerScoresData];

        for (var i = 0; i < _bakerScoresData.length; i++) {
            const currentState = this.state.bakerScoresData[i];
            const trackedState = _bakerScoresData[i];            
        }

        this.setState({
            _bakerScoresData
        })
    }

    bakerScoresHaveChanges = (a, b) => {
        let has = false;


        return has;
    }

    resetStandardBowlersChangeTracking = () => {
        const _standardGamesFlatData = this.state._standardGamesFlatData ? [...this.state._standardGamesFlatData] : [...this.state.standardGamesFlatData];

        for (var i = 0; i < _standardGamesFlatData.length; i++) {
            const currentState = this.state.standardGamesFlatData[i];
            const trackedState = _standardGamesFlatData[i];

            trackedState.bowlerName = currentState.bowlerName;
            trackedState.bowlerId = currentState.bowlerId;
            trackedState.bowled = currentState.bowled;
        }

        this.setState({
            _standardGamesFlatData
        })
    }

    bowlerHasChanges = (a, b) => {
        return ((a.bowlerName != b.bowlerName) || (a.bowlerId != b.bowlerId) || (a.bowled != b.bowled));
    }

    resetStandardScoresChangeTracking = () => {
        const _standardGamesFlatData = this.state._standardGamesFlatData ? [...this.state._standardGamesFlatData] : [...this.state.standardGamesFlatData];

        for (var i = 0; i < _standardGamesFlatData.length; i++) {
            const currentState = this.state.standardGamesFlatData[i];
            const trackedState = _standardGamesFlatData[i];
            
            for (const p in currentState){
                if (p.startsWith("gameNo")) {
                    trackedState[p] = currentState[p];
                }
            }
        }

        this.setState({
            _standardGamesFlatData
        })
    }

    flattenBowlerStandardGames = (standardGames) => {
        let standardGamesFlatData = [];
        (standardGames || []).forEach(obj => {
            standardGamesFlatData.push({ ...obj, ...this.flattenScores(obj.scores) });
        });        
        return standardGamesFlatData;
    }

    flattenScores = (scores) => {
        let obj = {};
        scores.forEach(scoreRow => {
            obj['gameNo' + scoreRow.gameNo] = scoreRow.score;
            obj['gameId' + scoreRow.gameNo] = scoreRow.individualGameScoreId;
            obj['combinedScoresId' + scoreRow.gameNo] = scoreRow.individualCombinedScoresId;
        });
        return obj;
    }

    generateTeamScores = () => {
        const { teamScores } = this.props;
        const { changedStandardGames, changedStandardBowlers, changedBakerScores, changedBakerBowlers } = this.state;

        let bakerScoresData = teamScores.bakerScores.map(item => Object.assign({}, item));
        let bakerBowlersData = teamScores.bakerBowlers.map(item => Object.assign({}, item));
        let standardGamesFlatData = this.flattenBowlerStandardGames(teamScores.standardGames.map(item => Object.assign({}, item)));

        return (<Panel key={teamScores.usbcSchoolId} style={{ marginTop: '-15px' }} >
            <div className='col-sm-5'>
                <span style={{ paddingBottom: '20px', fontWeight: 'bold' }}>
                    <i className='fa fa-university' aria-hidden="true" />&nbsp;&nbsp;{teamScores.schoolName}&nbsp;-&nbsp;
                    {teamScores.numberStandardGames} Standard Games&nbsp;&nbsp;
                </span>
            </div>
            <div style={{ paddingRight: '15px', fontWeight: 'bold' }}>
                <i className='fa fa-calendar' aria-hidden="true" />&nbsp;&nbsp;<span style={{ textAlign: 'right' }}>{this.props.eventName}</span>
            </div>
            {standardGamesFlatData && <div className='col-sm-12' style={styles.scoresDiv}>
                <ReactTable
                    data={standardGamesFlatData}
                    columns={this.generateColumns(((standardGamesFlatData[0] || {}).scores || []).length)} 
                    defaultPageSize={standardGamesFlatData.length}
                    showPagination={false}
                    className="-striped -highlight"
                />
                <Button className='btn-default' style={{ marginTop: '5px', color: blue }} disabled={(changedStandardGames.length === 0) && (changedStandardBowlers.length === 0)} onClick={this.handleSaveStandardData}><i className='fa fa-edit' aria-hidden="true" />&nbsp;&nbsp;Update Scores</Button>
            </div>}
            {bakerScoresData && teamScores.schoolName && <div className='col-sm-11' style={{ marginTop: '10px' }}>
                <span style={{ paddingBottom: '20px', fontWeight: 'bold' }}>
                    <i className='fa fa-university' aria-hidden="true" />&nbsp;&nbsp;{teamScores.schoolName}&nbsp;-&nbsp;
                    {bakerScoresData.length} Baker Games&nbsp;&nbsp;
                </span>
            </div>}
            {bakerBowlersData && <div className='col-sm-5' style={styles.scoresDiv}>
                <ReactTable
                    data={bakerBowlersData}
                    columns=
                    {[
                        { Header: "Athlete", accessor: "bowlerName", headerStyle: styles.tableHeader, width: 185, Cell: this.renderEditableBakerBowlersName },
                        { Header: "Member ID", accessor: "bowlerId", headerStyle: styles.tableHeader, width: 100, Cell: this.renderEditableBakerBowlersID },
                        { Header: "Bowled", accessor: "bowled", headerStyle: styles.tableHeader, width: 65, Cell: this.renderEditableBakerBowlersBowled },
                    ]}
                    defaultPageSize={bakerBowlersData.length}
                    showPagination={false}
                    className="-striped -highlight"
                />
                <Button className='btn-default' style={{ marginTop: '5px', color: blue }} disabled={(changedBakerBowlers.length === 0)} onClick={this.handleSaveBakerBowlers}><i className='fa fa-edit' aria-hidden="true" />&nbsp;&nbsp;Update Information</Button>
            </div>}
            {bakerScoresData && <div className='col-sm-2' style={{ ...styles.scoresDiv, marginLeft: '10px' }}>
                <ReactTable
                    data={bakerScoresData}
                    columns=
                    {[
                        { Header: "Game", accessor: "gameNo", headerStyle: styles.tableHeader, width: 50 },
                        { Header: "Score", accessor: "score", headerStyle: styles.tableHeader, width: 65, Cell: this.renderEditableBakerScores },
                    ]}
                    defaultPageSize={bakerScoresData.length}
                    showPagination={false}
                    sortable={false}
                    className="-striped -highlight"
                />
                <Button className='btn-default' style={{ marginTop: '5px', color: blue }} disabled={(changedBakerScores.length === 0)} onClick={this.handleSaveBakerScores}><i className='fa fa-edit' aria-hidden="true" />&nbsp;&nbsp;Update Baker Scores</Button>
            </div>}
        </Panel>)
    }    

    generateColumns = (standardgames) => {
        var columns = [
            { Header: "Athlete", accessor: "bowlerName", headerStyle: styles.tableHeader, width: 185, Cell: this.renderEditableBowlerName },
            { Header: "Member ID", accessor: "bowlerId", headerStyle: styles.tableHeader, width: 95, Cell: this.renderEditableBowlerId },
            { Header: "Bowled", accessor: "bowled", headerStyle: styles.tableHeader, width: 65, Cell: this.renderEditableBowled },
        ];

        for (let game = 1; game <= standardgames; game++) {
            const name = 'gameNo' + game;
            columns.push({ Header: `Game ${game}`, accessor: name, headerStyle: styles.tableHeader, width: 55, Cell: this.renderEditableStandardScores });
        }

        return columns
    }

    render() {
        const { standardGamesFlatData, bakerScoresData } = this.state;
        const scoresExist = ((standardGamesFlatData != undefined) || (bakerScoresData != undefined));
        return (
            <ContentWrapper>
                <Row>
                    <Col sm={12}>
                        {(scoresExist) && this.generateTeamScores()}
                        {(!scoresExist) && (
                            <Panel>
                                <span style={{ color: warning, fontSize: '105%' }}>
                                    <i className='fa fa-exclamation-circle' aria-hidden="true" />&nbsp;&nbsp;No team scores are available
                                </span>
                            </Panel>
                        )}
                    </Col>
                </Row>
            </ContentWrapper>
        );
    }
}

AmendScores.propTypes = {
    teamScores: PropTypes.object,
    eventName: PropTypes.string,
    token: PropTypes.string
}

export default AmendScores



// WEBPACK FOOTER //
// ./src/components/pages/Event/AmendScores.js